import { jsx as t } from "react/jsx-runtime";
const s = ({ onClick: r, style: o, position: n, iconColor: e }) => /* @__PURE__ */ t("button", { style: o, onClick: r, children: n === "prev" ? /* @__PURE__ */ t(
  "svg",
  {
    width: "7",
    height: "10",
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M5.5 1L1.5 5L5.5 9",
        stroke: e,
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
) : /* @__PURE__ */ t(
  "svg",
  {
    width: "7",
    height: "10",
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M1.5 1L5.5 5L1.5 9",
        stroke: e,
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
) });
export {
  s as default
};
